// extracted by mini-css-extract-plugin
export default {"adminTabHeader":"TabPanel_adminTabHeader__OhD9c","adminTabNav":"TabPanel_adminTabNav__WmqaL","adminTabNavActive":"TabPanel_adminTabNavActive__3gvZB"};